((Drupal, once) => {
  'use strict';

  // CONFIG
  const DEBUG = false;
  const MAX_VISIBLE_COLLAPSED = 6;
  const GRID_SELECTOR = '#views-bootstrap-homepage-content-block-1--2 .row';

  Drupal.behaviors.solutionsToggle = {
    attach(context) {
      const grids = once('solutions-toggle-v3', GRID_SELECTOR, context);

      grids.forEach((grid, gridIdx) => {
        const items = Array.from(grid.children);

        // Index and tag items with data attributes
        items.forEach((item, i) => {
          item.dataset.solIndex = String(i + 1); // 1-based
          item.dataset.origOrder = String(i + 1);
          if (!item.dataset.origDisplay) {
            const computed = window.getComputedStyle(item).display;
            item.dataset.origDisplay = computed === 'none' ? 'none' : 'block';
          }
        });

        // ✅ Console log original list
        if (DEBUG) {
          console.group(`Solutions grid #${gridIdx + 1} – Original list`);
          items.forEach((item) => {
            const number = item.dataset.solIndex;
            const titleEl = item.querySelector('h2 a');
            const title = titleEl ? titleEl.textContent.trim() : '(no title)';
            console.log(`${number}: ${title}`);
          });
          console.groupEnd();
        }

        if (items.length <= MAX_VISIBLE_COLLAPSED) return;

        const applyCollapsed = () => {
          const chosen = items
            .filter(item => item.querySelector('.views-field-icon-title.sticky'))
            .slice(0, MAX_VISIBLE_COLLAPSED);

          // ✅ Console log collapsed order 
          if (DEBUG) {
            console.group(`Solutions grid #${gridIdx + 1} – Collapsed order`);
            chosen.forEach((item, i) => {
              const titleEl = item.querySelector('h2 a');
              const title = titleEl ? titleEl.textContent.trim() : '(no title)';
              console.log(`${i + 1}. ${item.dataset.solIndex}: ${title}`);
            });
            console.groupEnd();
          }

          items.forEach((item) => {
            const pos = chosen.indexOf(item);
            if (pos !== -1) {
              item.style.order = String(pos + 1);
              item.style.display = 'block';
            } else {
              item.style.display = 'none';
              item.style.order = '';
            }
          });
        };

        const applyExpanded = () => {
          items.forEach((item) => {
            item.style.display = '';
            item.style.order = '';
          });
        };

        applyCollapsed();

        const toggleBtn = document.createElement('button');
        toggleBtn.textContent = Drupal.t('Discover more solutions');
        toggleBtn.className = 'solutions-toggle-btn';
        toggleBtn.type = 'button';
        toggleBtn.setAttribute('aria-expanded', 'false');
        const controlId = `solutions-grid-${gridIdx}`;
        grid.id = grid.id || controlId;
        toggleBtn.setAttribute('aria-controls', grid.id);

        toggleBtn.addEventListener('click', () => {
          const expanded = toggleBtn.classList.toggle('expanded');
          if (expanded) {
            applyExpanded();
            toggleBtn.textContent = Drupal.t('Show fewer solutions');
            toggleBtn.setAttribute('aria-expanded', 'true');
          } else {
            applyCollapsed();
            toggleBtn.textContent = Drupal.t('Discover more solutions');
            toggleBtn.setAttribute('aria-expanded', 'false');
          }
        });

        grid.parentNode.insertBefore(toggleBtn, grid.nextSibling);
      });
    }
  };
})(Drupal, once);
